import React, { useMemo } from 'react'
import { ViewStyle } from 'react-native'

import { LinearGradient } from 'expo-linear-gradient'

import { tID } from '../../utils'

export interface AiLinearGradientProps {
  children?: React.ReactNode
  colors?: ArrayMinTwo<string>
  style?: ViewStyle
  rotationAngle?: number
  height?: number
  borderRadius?: number
  testID?: string
}

const DEFAULT_ROTATION_ANGLE = 259

const angleToGradientCoords = (degrees: number) => {
  const radians = (degrees * Math.PI) / 180
  const x = Math.sin(radians)
  const y = Math.cos(radians)
  // Transform degrees into vector with length 1 (rectangular coordinates)
  // see https://docs.expo.dev/versions/latest/sdk/linear-gradient/#types
  return {
    start: { x: 0.5 - x / 2, y: 0.5 + y / 2 },
    end: { x: 0.5 + x / 2, y: 0.5 - y / 2 },
  }
}

/**
 * AiLinearGradient provides a consistent AI-themed linear gradient container
 * with the standard green-teal-blue color palette used across AI features.
 */
export const AiLinearGradient: React.FC<AiLinearGradientProps> = ({
  children,
  colors = ['#43A484', '#06A0BA', '#5F76C4'],
  style,
  rotationAngle = DEFAULT_ROTATION_ANGLE,
  height,
  borderRadius,
  testID = tID('AiLinearGradient'),
}) => {
  const gradientCoords = useMemo(() => angleToGradientCoords(rotationAngle), [rotationAngle])
  return (
    <LinearGradient
      testID={testID}
      colors={colors}
      locations={[0.0312, 0.5385, 0.98]}
      start={gradientCoords.start}
      end={gradientCoords.end}
      style={[{ height, borderRadius }, style]}
    >
      {children}
    </LinearGradient>
  )
}
